import { object } from 'zod';

export const QuizEssayDataSchema = object({});
